import { Skeleton, Stack } from "@mui/material"
import type { FC, RefObject } from "react"

import type { Challenge } from "../../api/hooks/vote"
import { VoteHero } from "./components/hero"
import { Prompt } from "./components/prompt"

interface Props {
	challenge: Maybe<Challenge>
	titleRef: RefObject<HTMLDivElement>
}
export const Header: FC<Props> = ({ challenge, titleRef }) => (
	<>
		<VoteHero challenge={challenge} />
		<Stack mb={7} mx='auto' maxWidth='500px' width='90%' ref={titleRef}>
			{challenge ? (
				<Prompt description={challenge.intro} />
			) : (
				<Skeleton height='100px' />
			)}
		</Stack>
	</>
)
